<template>
  <div class="min-h-screen bg-[#f6f7f9] py-10">
    <div class="max-w-[900px] mx-auto px-6">
      <div class="bg-white rounded-2xl border border-[#e9eaec] shadow-sm overflow-hidden">
        <div class="h-1 bg-gradient-to-r from-[#FFD500] to-[#FFC107]"></div>
        <div class="px-8 py-10">

          <nav class="flex items-center gap-2 text-[0.82rem] text-[#999] mb-6">
            <router-link to="/" class="hover:text-[#111] transition-colors no-underline"><i class="bi bi-house"></i></router-link>
            <i class="bi bi-chevron-right text-[0.7rem]"></i>
            <span class="text-[#111] font-medium">Cookiebeleid</span>
          </nav>

          <h1 class="text-[2rem] font-extrabold text-[#111] mb-2 leading-tight">Cookiebeleid</h1>
          <p class="text-[0.82rem] text-[#aaa] mb-8">Laatste update: mei 2025</p>

          <div class="prose-content">

            <h2>Wat zijn cookies?</h2>
            <p>Cookies zijn kleine tekstbestandjes die op jouw apparaat worden opgeslagen wanneer je onze website bezoekt. Ze helpen ons de website goed te laten werken en jouw ervaring te verbeteren.</p>

            <h2>Welke cookies gebruiken wij?</h2>

            <h3>Noodzakelijke cookies</h3>
            <p>Deze cookies zijn essentieel voor de werking van onze website, zoals het bijhouden van je winkelwagen en inlogstatus. Je kunt deze niet uitschakelen.</p>

            <h3>Functionele cookies</h3>
            <p>Deze cookies onthouden jouw voorkeuren, zoals taalinstellingen en producten op je verlanglijst.</p>

            <h3>Analytische cookies</h3>
            <p>Wij gebruiken Google Analytics om te begrijpen hoe bezoekers onze website gebruiken. De gegevens worden geanonimiseerd en niet gedeeld met derden. Je kunt analytische cookies weigeren via ons cookiebanner.</p>

            <h3>Marketing cookies</h3>
            <p>Met jouw toestemming plaatsen wij cookies voor gepersonaliseerde advertenties via Google Ads. Je kunt dit altijd weigeren of intrekken.</p>

            <h2>Cookies beheren</h2>
            <p>Je kunt cookies beheren via je browser­instellingen. Let op: het uitschakelen van cookies kan de functionaliteit van onze website beperken. Meer informatie vind je op <a href="https://www.consumentenbond.nl/veilig-internetten/cookies-verwijderen" target="_blank" rel="noopener">consumentenbond.nl</a>.</p>

            <h2>Meer informatie</h2>
            <p>Zie ons <router-link to="/privacy">privacybeleid</router-link> voor meer informatie over hoe wij omgaan met jouw persoonsgegevens.</p>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style scoped>
.prose-content :deep(h2) { font-size: 1.125rem; font-weight: 700; color: #111; margin-top: 1.75rem; margin-bottom: 0.625rem; padding-bottom: 0.375rem; border-bottom: 1px solid #f0f0f0; }
.prose-content :deep(h3) { font-size: 1rem; font-weight: 700; color: #222; margin-top: 1.25rem; margin-bottom: 0.5rem; }
.prose-content :deep(p)  { font-size: 0.9375rem; color: #444; line-height: 1.7; margin-bottom: 0.875rem; }
.prose-content :deep(a)  { color: #b8860b; text-decoration: underline; }
.prose-content :deep(a:hover) { color: #111; }
</style>
